import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_chevron-down",
  "use": "icon_chevron-down-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" id=\"icon_chevron-down\"><path stroke=\"currentColor\" stroke-linecap=\"square\" d=\"m6 9 6 6 6-6\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol